export const USER_DATA_UPDATED_EVENT = 'jobscribe:user-data-updated';

export function notifyUserDataUpdated() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(USER_DATA_UPDATED_EVENT));
  }
}
